var AdaptiveImage = require("../node_modules/react-native-web-image-loader/lib/modules/adaptiveImage.js").default;

module.exports = new AdaptiveImage({
    uri: __webpack_public_path__ + "checked-circle.019cf7ac.png","uri@2x": __webpack_public_path__ + "checked-circle.1ee36f79.png","uri@3x": __webpack_public_path__ + "checked-circle.0a158f2e.png",
    width: 60,
    height: 60
});